import { createAsyncThunk } from "@reduxjs/toolkit";
import client from "../../../app/core/client-http/client";
import { createSlice } from "@reduxjs/toolkit";
import { downloadBlob } from "../../../utils/functions/downloadBlob";

export const doUploadLogoFileOnS3 = createAsyncThunk(
  "uploadLogo/personalizza-studio",
  async ({ url, file, type }, thunkAPI) => {
    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": type,
        },
        body: file,
      });
      if (response.ok) {
        return response.url;
      } else {
        throw new Error(
          "Errore durante il caricamento del file su Azure Blob Storage"
        );
      }
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

export const getUploadLogoURL = createAsyncThunk(
  "createStudio/getUploadLogoURL",
  async () => {
    const endpoint = "/admin/studio/getuploadurl";
    const response = await client.get(endpoint);
    return response.data;
  }
);

// export const setStudioLogo = createAsyncThunk(
//   "editStudio/set-studio-logo",
//   async ({ body, studioId }, thunkAPI) => {
//     const endpoint = `admin/studio/${studioId}/setlogo`;
//     const response = await client.post(endpoint, body);
//     return response.data;
//   }
// );

// export const deleteStudioLogo = createAsyncThunk(
//   "editStudio/delete-studio-logo",
//   async (studioId, thunkAPI) => {
//     const endpoint = `/admin/studio/${studioId}/deletelogo`;
//     const response = await client.post(endpoint, null, { studioId: studioId });
//     return response.data;
//   }
// );

export const getUserStudio = createAsyncThunk(
  "getUserStudio",
  async (studioId) => {
    const endpoint = `/admin/studio/${studioId}`;
    const response = await client.get(endpoint);
    return response.data;
  }
);

// export const getStudioLogo = createAsyncThunk(
//   "gestisci-studio/get-studio-logo",

//   async (logoUrl, thunkAPI) => {
//     const endpoint = logoUrl;
//     const response = await client.get(endpoint, null, { type: "blob" });
//     return response;
//   }
// );

export const doReportOperator = createAsyncThunk(
  "operatorManagement/get-report-operator",
  async (reportOperatorData, thunkAPI) => {
    const endpoint = "/admin/commercialista/export";
    const response = await client.get(endpoint, null, { type: "blob" });
    downloadBlob("Report operatore.xls", response);
  }
);

/*************** SLICE */

// Initial state for the slice
const initialState = {
  studio: null, // or whatever initial state you want
  loading: "idle", // The loading state
  error: null, // Any potential error
};

// Create the gestisciStudioSlice
const gestisciStudioSlice = createSlice({
  name: "gestisciStudioSlice", // Name of the slice
  initialState,
  reducers: {
    // You can define additional reducers here if needed
  },
});

// Export the actions and reducer
export const { actions, reducer } = gestisciStudioSlice;
export default gestisciStudioSlice;
